/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

const baseStyles = () => {
    return css`
        display: flex;
        gap: 0.8rem;
        margin-bottom: var(--layout-spacing-8);
        min-height: 2.6rem;

        .price {
            margin: 0;
        }

        .price-before-discount {
            ${theme.typography.body_normal_highlight};
            color: var(--colors-text-primary);
            text-decoration: line-through;
        }
    `;
};

export const styles = () => css`
    ${baseStyles()}
`;
